/**
 * Determine what the current media query is
 * Values are the same as breakpoints values defined in variables.css
 */
export default class MediaUtils {
  static get window() {
    if (typeof window !== 'undefined') {
      return window;
    }

    return {
      matchMedia() {
        return {
          matches: false,
        };
      },
    };
  }

  static get isExtraSmallAndSmaller() {
    return MediaUtils.window.matchMedia('(max-width: 319px)').matches;
  }
  static get isExtraSmallAndGreater() {
    return MediaUtils.window.matchMedia('(min-width: 320px)').matches;
  }

  static get isSmallAndSmaller() {
    return MediaUtils.window.matchMedia('(max-width: 424px)').matches;
  }
  static get isSmallAndGreater() {
    return MediaUtils.window.matchMedia('(min-width: 425px)').matches;
  }

  static get isMobileAndSmaller() {
    return MediaUtils.window.matchMedia('(max-width: 767px)').matches;
  }
  static get isMobileAndGreater() {
    return MediaUtils.window.matchMedia('(min-width: 768px)').matches;
  }

  static get isTabletAndSmaller() {
    return MediaUtils.window.matchMedia('(max-width: 969px)').matches;
  }
  static get isTabletAndGreater() {
    return MediaUtils.window.matchMedia('(min-width: 970px)').matches;
  }

  static get isDesktopAndSmaller() {
    return MediaUtils.window.matchMedia('(max-width: 1366px)').matches;
  }
  static get isDesktopAndGreater() {
    return MediaUtils.window.matchMedia('(min-width: 1367px)').matches;
  }

  static get isLargeDesktopAndSmaller() {
    return MediaUtils.window.matchMedia('(max-width: 1599px)').matches;
  }
  static get isLargeDesktopAndGreater() {
    return MediaUtils.window.matchMedia('(min-width: 1600px)').matches;
  }

  static get isMouseDevice() {
    if (MediaUtils.window) {
      return 'onclick' in document.documentElement;
    }

    return false;
  }
  static get isTouchDevice() {
    if (MediaUtils.window) {
      return 'ontouchstart' in document.documentElement;
    }

    return false;
  }
}
